// 登录接口
import {
	axios
} from '../utils/http.js'

//获取文件列表
export function allFileManager(data) {
	return axios({
		url: '/v3/FileManager/List',
		method: 'post',
		data: data
	})
}

//添加文件夹
export function addFolder(data) {
	return axios({
		url: '/v3/FileManager/AddFolder',
		method: 'post',
		data: data
	})
}
//重命名文件或文件夹
export function renameFileManager(data) {
	return axios({
		url: '/v3/FileManager/Rename',
		method: 'post',
		data: data
	})
}
//删除文件或文件夹
export function deleteFileManager(data) {
	return axios({
		url: '/v3/FileManager/Del',
		method: 'post',
		data: data
	})
}

//上传文件
export function uploadFileManager(data) {
	return axios({
		url: '/v3/FileManager/Add',
		method: 'post',
		data: data,
		headersFlag: 'json'
	})
}

//获取存储信息
export function storageInfo(data) {
	return axios({
		url: '/v3/FileManager/StorageInfo',
		method: 'post',
		data: data
	})
}
